<template>
  <v-app id="inspire">
    <v-row dense>
        <v-col cols="8" class="hidden-sm-and-down">
            <v-card 
                height="100%" 
                :style="images.back"
            >
            </v-card>                
        </v-col>
        <v-col class="text-center white pa-4">
            <img src="/img/logo.png" width="200" style="margin-top: 100px;">
            <div class="mt-2">
                <alert-component v-if="$vuetify.breakpoint.mdAndUp" :alert="alerts.login"></alert-component>
            </div>
               
            <v-form ref="form" @submit.prevent="validate">
                <v-text-field
                    outlined
                    append-icon="mdi-email"
                    v-model="formData.email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                    autofocus
                >
                </v-text-field>

                <v-text-field v-if="!forgetpassword"
                    v-model="formData.password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="passwordRules"
                    :type="show1 ? 'text' : 'password'"
                    label="Senha"
                    autocomplete="new-password"
                    @click:append="show1 = !show1"
                    outlined
                    @keydown.enter="validate"
                    name="no-store-password"
                    id="no-store-password"
                ></v-text-field>

                <div class="body-2 text-right mt-0 mb-6">
                    <a v-if="!forgetpassword" @click="ForgetPassword()">
                        Esqueceu a senha?
                    </a>
                    <a v-if="forgetpassword" @click="ForgetPassword()">
                        Voltar para o login
                    </a>
                </div>
                    
                <v-btn
                    :loading="loading"
                    :disabled="loading"
                    color="primary"
                    large
                    block
                    v-if="!forgetpassword"   
                    type="submit"
                >
                    Entrar
                </v-btn>

                <template v-if="this.$vuetify.breakpoint.smAndDown">
                    <div class="d-flex align-center my-4">
                        <v-divider></v-divider>
                        <span class="mx-4 grey--text body-2">OU</span>
                        <v-divider></v-divider>
                    </div>

                    <v-btn
                        :loading="loadingWebAuthn"
                        :disabled="loading || loadingWebAuthn"
                        color="primary"
                        outlined
                        large
                        block
                        @click="handleBiometricLogin"
                    >
                        <v-icon left>mdi-fingerprint</v-icon>
                        Entrar com Chave de Acesso
                    </v-btn>
                </template>

                <v-btn
                    :loading="loading"
                    :disabled="loading"
                    large
                    block
                    @click="validate2"
                    v-if="forgetpassword"
                    elevation="0"
                    
                >
                    Solicitar nova Senha
                </v-btn>
            </v-form>    

            <p>&nbsp;</p>
            <p class="caption"> {{ new Date().getFullYear() }} — AYT Site e Sistemas </p> 
            <p class="caption" v-if="!this.$vuetify.breakpoint.smAndDown"> 
                Tel: (11) 3042-3243 (WhatsApp)  <br />
                E-mail: contato@ayt.com.br
            </p>
            <p>&nbsp;</p>
            <p class="caption">{{ ip }}</p>
        </v-col>
    </v-row>
    
    <vue-snotify></vue-snotify>
        
  </v-app>
</template>

<script>
import AlertComponent from '@/components/alert/AlertComponent.vue';
import webauthnMixin from '@/mixins/webauthnMixin';
import { allowedEmails } from '@/constants/variaveisProvisorias.js';

export default {
    components: {
        AlertComponent
    },

    mixins: [webauthnMixin],

    created(){
        this.closeRequestPassword()
    },

    // 3. RECUPERAR O E-MAIL: Preenche automaticamente se já logou antes
    mounted() {
        const lastEmail = localStorage.getItem('last_login_email');
        if (lastEmail) {
            this.formData.email = lastEmail;
        }

        this.getIp();
    },

    // provisorio para teste chave de acesso (webauthn)
    computed: {
        showBiometricOption() {
            // Verifica se NÃO está em "esqueci a senha"
            // Verifica se é mobile (smAndDown)
            // Verifica se o email atual está na lista de permitidos
            const isAllowedEmail = this.allowedEmails?.includes(this.formData.email);
            
            return !this.forgetpassword && 
                this.$vuetify.breakpoint.smAndDown && 
                isAllowedEmail;
        }
    },
    // fim provisorio

    data () {   
        return {
            // provisorio para teste chave de acesso (webauthn)
            allowedEmails: allowedEmails,
            // fim provisorio

            loading: false,
            alerts: {
                login: {
                    type: 'warning',
                    icon: 'mdi-alert-outline',
                    messages: [
                        '<span class="text-subtitle-2">Recomendamos utilizar a janela anônima.</span>',
                        '<span class="text-subtitle-2">* Não use o mesmo e-mail e senha <strong> simultaneamente </strong> em mais de uma janela ou dispositivo.</span>'
                    ]
                },
            },

            images: {
                logo: 'logo.png',
                back: `background: url('./img/welcome.jpg') no-repeat center center; background-size: cover;`
            },

            formData: {
                email: '',
                password: '',
            },
            
            show1: false,
            forgetpassword: false,
            sendemail: false,

            emailRules: [
                v => !!v || 'E-mail e obrigatório',
                v => /.+@.+/.test(v) || 'E-mail não é válido',
            ],

            passwordRules: [
                v => !!v || 'Senha obrigatória',
            ],
            
            ip: null,
        }   
    },
    
    methods: {
        login () {
            this.loading = true

            this.formData.device_name = this.$browserDetect.meta.ua
            this.$store.dispatch('login', this.formData)    
                        .then(() => {
                            this.$router.push({name: 'admin.dashboard'})
                            this.$store.dispatch('loadPortalItems')
                        })
                        .catch(error => {
                            this.loading = false
                            this.$snotify.error('E-mail ou senha incorreto', error)
                        })
        },

        validate () {
            if (this.$refs.form.validate()) {
              this.snackbar = true
              this.login()
            }
        },

        validate2 () {
            if (this.$refs.form.validate()) {
              this.snackbar = true
              this.SendRequestPassword()
            }
        },

        ForgetPassword(){
            this.forgetpassword = !this.forgetpassword
        },

        SendRequestPassword(){
            this.$store.dispatch('sendRequestPassword', this.formData)
                        .then(() => {
                           this.$snotify.success('Verifique seu e-mail. Solicitaçāo enviada')
                           this.ForgetPassword()
                        })
                        .catch(error => {
                            this.loading = false
                            this.$snotify.error('erro', error)
                        })
        },

        closeRequestPassword(){
            if(this.$router.currentRoute.query.request && this.$router.currentRoute.query.request != ''){
                const params = {}
                params.item_id = this.$router.currentRoute.query.request 

                this.$store.dispatch('closeRequestPassword', params)
                        .then(() => {
                           this.$snotify.success('Verifique seu e-mail. Uma nova senha foi enviada')
                        })
                        .catch(error => {
                            this.loading = false
                            this.$snotify.error('erro', error)
                        })
            }
        },
        
        async handleBiometricLogin() {
            const email = this.formData.email;

            // Valida se o usuário digitou o e-mail antes de clicar
            if (!email) {
                this.$snotify.warning('Por favor, digite seu e-mail para usar a chave de acesso.');
                return;
            }

            try {
                // Chama a função do seu mixin
                await this.authenticateWithPasskey(email);
                
                // Sucesso! O backend já validou e iniciou a sessão (Laravel Session/Cookie).
                
                // Salva o e-mail no navegador para a próxima visita
                localStorage.setItem('last_login_email', email);

                this.$snotify.success('Login realizado com sucesso!');
                
                // Dispara as ações de roteamento que você já usa no login normal
                this.$router.push({name: 'admin.dashboard'});
                this.$store.dispatch('loadPortalItems');

            } catch (error) {
                // Se der erro (ex: e-mail não achado ou sem biometria)
                if (error.response && (error.response.status === 422 || error.response.status === 404)) {
                    this.$snotify.warning('Nenhuma chave encontrada para este e-mail. Use sua senha.');
                } else if (error.name !== 'NotAllowedError') {
                    // Ignora o 'NotAllowedError' que é quando o usuário aperta 'Cancelar' na janela do TouchID
                    this.$snotify.error('Erro ao processar chave de acesso.');
                    console.error('Falha biométrica:', error);
                }
            }
        },

        async getIp() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.ip = data.ip;
            } catch (error) {
                console.error("Erro ao buscar o IP:", error);
            }
        }

    }
}
</script>

<style scoped>
#inspire {
  background-color:#f1f4f6;
  font-family: 'Verdana';
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 200px;
  width: 50%;
}

</style>
